// import React, { useEffect, useState, useRef } from "react";
// import StudentPlaceholder from "./Student_placeholder.png";
// import "./studentdashboard.css";
// import { ResponsiveBar } from "@nivo/bar";
// import { ResponsiveLine } from "@nivo/line";
// import DropDownUP from "./DropwondownSingleStudent";
// import FormInputs from "../Reports/DummyReportPage/FormInputs";
// import RedArrow from "../../Assets/Images/CommanImages/More_up_arrow.png";
// import SpeedoMeterStudentCNG from "./student_speedometer.png";
// import TableComponent from "../Reports/components/TableCompoenent";
// import dayjs from "dayjs";
// import ReactSpeedometer from "react-d3-speedometer";
// import { ResponsivePie } from "@nivo/pie";
// import { API_BASE_URL } from "../../Config/Config";
// const processAttendanceData = (data) => {
//   let present = 0;
//   let absent = 0;
//   let holidays = 0;

//   data.forEach((item) => {
//     if (item.day_type === "Holiday") {
//       holidays++;
//     } else if (item.day_type === "Working" && item.punch_in !== null) {
//       present++;
//     } else if (item.day_type === "Working" && item.punch_in === null) {
//       absent++;
//     }
//   });

//   return [
//     {
//       id: "Present",
//       label: "Present",
//       value: present,
//     },
//     {
//       id: "Absent",
//       label: "Absent",
//       value: absent,
//     },
//     {
//       id: "Holiday",
//       label: "Holiday",
//       value: holidays,
//     },
//   ];
// };

// const StudentDashboard = ({ dataClient }) => {
//   const [studentData, setStudentData] = useState(null);
//   const [progressData, setProgressData] = useState([]);
//   const [isClicked, setIsClicked] = useState(false);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedSubjectLabel, setSelectedSubjectLabel] = useState("");
//   const [subjects, setSubjects] = useState([]);
//   const [courseOpted, setCourseOpted] = useState("1");
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(true);
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const headers = ["Date", "Day", "Day Type", "Punch In"];
//   const pieChartData = processAttendanceData(attendanceData);

//   const [value, setValues] = useState({
//     month: "",
//     start_month: "",
//     month: "Month to Date",
//     end_month: "",
//     subject_id: [],
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//   });
//   const [items, setItems] = useState([
//     // {
//     //   date: "10/09/24",
//     //   text: "Fees payment extension requested by wards.",
//     //   isChecked: false,
//     //   isRed: false,
//     // },
//     // {
//     //   date: "19/09/24",
//     //   text: "Student will be absent from 20/09/24 to 25/09/24.",
//     //   isChecked: false,
//     //   isRed: false,
//     // },
//   ]);
//   const [inputValue, setInputValue] = useState("");
//   const [inputVisible, setInputVisible] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);
//   const textareaRef = useRef(null);
//   // const userName = "User Name";

//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const accessToken = localStorage.getItem("other");

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//   };

//   // const handleKeyDown = (e) => {
//   //   if (e.key === "Enter" && !e.shiftKey) {
//   //     e.preventDefault();

//   //     if (inputValue.trim()) {
//   //       const isRed = inputValue.startsWith("@KeepRed");
//   //       const cleanText = isRed
//   //         ? inputValue.replace("@KeepRed", "").trim()
//   //         : inputValue;

//   //       const newItem = {
//   //         date: dayjs().format("DD/MM/YY"),
//   //         text: cleanText,
//   //         isChecked: isChecked,
//   //         isRed: isRed || isChecked,
//   //       };

//   //       setItems((prevItems) => [...prevItems, newItem]);
//   //       setInputValue("");
//   //       setInputVisible(false);
//   //       setIsChecked(false);
//   //       if (textareaRef.current) {
//   //         textareaRef.current.style.height = "auto";
//   //       }
//   //     }
//   //   }
//   // };

//   const handleKeyDown = async (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();

//       if (inputValue.trim()) {
//         const isRed = inputValue.startsWith("@KeepRed");
//         const cleanText = isRed
//           ? inputValue.replace("@KeepRed", "").trim()
//           : inputValue;

//         const newItem = {
//           date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//           text: cleanText,
//           isChecked: isChecked,
//           isRed: isRed || isChecked,
//         };

//         // Post the note to the server
//         await postStudentNote(cleanText, isChecked);

//         // Update the local state
//         setItems((prevItems) => [...prevItems, newItem]);
//         setInputValue("");
//         setInputVisible(false);
//         setIsChecked(false);
//         if (textareaRef.current) {
//           textareaRef.current.style.height = "auto";
//         }
//       }
//     }
//   };

//   useEffect(() => {
//     if (textareaRef.current) {
//       textareaRef.current.style.height = "auto"; // Reset height
//       textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set to scrollHeight
//     }
//   }, [inputValue]);

//   const handleCheckboxChange = () => {
//     setIsChecked((prev) => !prev); // Toggle checkbox state
//   };

//   const handleDoubleClick = () => {
//     setInputVisible(true); // Show the input field on double-click
//   };
//   // const dataClient = {
//   //   client_schema_name: [
//   //     [],
//   //     [],
//   //     [],
//   //     [],
//   //     [],
//   //     [],
//   //     [{ client_display_name: "Sample Client", user_name: "Admin User" }],
//   //   ],
//   // };
//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (courseOpted) {
//         const response = await fetch(
//           `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${courseOpted}`
//         );
//         const data = await response.json();
//         setSubjects(data);
//         setSelectedSubjectLabel(""); // Reset the subject label
//       }
//     };

//     fetchSubjects();
//   }, []);

//   useEffect(() => {
//     fetch(
//       "https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-student-profile-details/?student_id=2",
//       {
//         headers: {
//           accept: "application/json",
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === 200 && data.data.length > 0) {
//           setStudentData(data.data[0]); // Store the first element of data array
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching student data:", error);
//       });
//   }, []); // Only runs on component mount

//   useEffect(() => {
//     fetch(
//       "https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-rpt-student-progress-card/?student_id=2",
//       {
//         headers: {
//           accept: "application/json",
//         },
//       }
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         if (data) {
//           const last10Data = data;

//           const transformedData = [
//             {
//               id: "Zoology",
//               data: last10Data.map((item) => ({
//                 x: item.assessment_name.substring(0, 7),
//                 y: item.Zoology_total_marks,
//               })),
//             },
//             {
//               id: "Physics",
//               data: last10Data.map((item) => ({
//                 x: item.assessment_name.substring(0, 7),
//                 y: item.Physics_total_marks,
//               })),
//             },
//             {
//               id: "Chemistry",
//               data: last10Data.map((item) => ({
//                 x: item.assessment_name.substring(0, 7),
//                 y: item.Chemistry_total_marks,
//               })),
//             },
//             {
//               id: "Botany",
//               data: last10Data.map((item) => ({
//                 x: item.assessment_name.substring(0, 7),
//                 y: item.Botany_total_marks,
//               })),
//             },
//           ];
//           setProgressData(transformedData);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching progress data:", error);
//       });
//   }, []);

//   const fetchAttendanceData = async () => {
//     try {
//       const response = await fetch(
//         "https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-student-attendance/?student_id=2&start_date=2024-06-14%2010%3A46%3A01&end_date=2024-10-14%2010%3A46%3A01",
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//           },
//         }
//       );
//       const data = await response.json();
//       if (Array.isArray(data)) {
//         const mappedData = data.map((item) => [
//           item.date_ || "N/A",
//           item.day_ || "N/A",
//           item.day_type || "N/A",
//           item.punch_in || "N/A",
//         ]);
//         setAttendanceData(mappedData);
//       } else {
//         console.error("Unexpected data format:", data);
//       }
//     } catch (error) {
//       console.error("Error fetching attendance data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const barData = [
//     {
//       year: "2003",
//       hotdog: 130,
//       burger: 150,
//       sandwich: 70,
//     },
//     {
//       year: "2004",
//       hotdog: 190,
//       burger: 250,
//       sandwich: 120,
//     },
//     {
//       year: "2005",
//       hotdog: 230,
//       burger: 200,
//       sandwich: 170,
//     },
//   ];

//   const handleToggle = () => {
//     setIsClicked((prev) => !prev);
//   };

//   const postStudentNote = async (noteText, disciplinaryFlag) => {
//     const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/add-student-notes`;
//     const params = new URLSearchParams({
//       student_id: "122",
//       note_text: noteText,
//       branch_id: clientBranchId,
//       username: userName,
//       device: "web",
//       disciplinary_flag: disciplinaryFlag,
//     });

//     try {
//       const response = await fetch(`${url}?${params.toString()}`, {
//         method: "POST",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}` // Include the access token in the headers
//         },
//       });

//       if (response.ok) {
//         const data = await response.json();
//         console.log("Note successfully posted:", data);
//         return data;
//       } else {
//         const errorData = await response.json();
//         console.error("Failed to post note:", errorData.message || response.statusText);
//       }
//     } catch (error) {
//       console.error("Error posting note:", error);
//     }
//   };

//   const fetchStudentNotes = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-notes/?student_id=122&branch_id=${clientBranchId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}` // Include the access token in the headers
//           }
//         }
//       );
//       const data = await response.json();
//       if (data.status === 200 && Array.isArray(data.data)) {
//         const formattedNotes = data.data.map((note) => ({
//           date: note.create_date,
//           text: note.note_text,
//           isChecked: note.disciplinary_flag,
//           isRed: note.disciplinary_flag,
//           username: note.username,
//         }));

//         setItems(formattedNotes); // Update the state directly with fetched data
//       } else {
//         console.error("Unexpected response format:", data);
//       }
//     } catch (error) {
//       console.error("Error fetching notes:", error);
//     }
//   };

//   useEffect(() => {
//     if (clientBranchId) {
//       fetchStudentNotes(clientBranchId);
//     }
//   }, [clientBranchId]); // Ensure this runs only when clientBranchId changes

//   return (
//     <>
//       {studentData ? (
//         <div
//           className="row-cs-uni header-student-dashboard"
//           style={{ marginBottom: "15px" }}
//         >
//           <div
//             className="col-cs2-uni-landing-student"
//             style={{ color: "#424242" }}
//           >
//             <img
//               src={StudentPlaceholder}
//               className="student_img_dashboard-student"
//               alt="Student Avatar"
//             />
//           </div>
//           <div
//             className="col-cs2-uni-landing-student3"
//             style={{ color: "#424242" }}
//           >
//             <h2 className="spaceing-student-details bottomAligned">
//               {studentData.student_full_name}
//             </h2>
//             <p className="spaceing-student-details">
//               Roll Number: {studentData.Roll_Number}
//             </p>
//           </div>
//           <div
//             className="col-cs2-uni-landing-student2"
//             style={{ color: "#424242" }}
//           >
//             <p className="spaceing-student-details top-margin-student">
//               Branch: {studentData.Branch_name}
//             </p>
//             <p className="spaceing-student-details">
//               Class Type: {studentData.class_type}
//             </p>
//             <p className="spaceing-student-details">
//               Course: {studentData.Course_Name}
//             </p>
//             <p className="spaceing-student-details">
//               Class: {studentData.Class_name}
//             </p>
//             <p className="spaceing-student-details">
//               Batch: {studentData.Batch}
//             </p>
//           </div>
//         </div>
//       ) : (
//         <p>Loading student data...</p>
//       )}
//       <div
//         className="student-dashboard-content"
//         style={{ marginBottom: "15px" }}
//       >
//         <div>
//           <div
//             style={{
//               backgroundColor: "#D6D6D6",
//               color: "#424342",
//               fontWeight: "700",
//               padding: "10px",

//               boxShadow: "4px 4px 4px 0px #00000040",
//             }}
//           >
//             Recent Activity
//           </div>
//           <div className="card1-student-dashboard recent-activity">
//             <div className="timeline-wrapper">
//               <div className="timeline">
//                 {[
//                   {
//                     time: "16/10/24",
//                     text: "  Submitted DPP-2 Physics.",
//                   },
//                   {
//                     time: "15/10/24",
//                     text: " Test Submitted Test-5 Chemistry.",
//                   },
//                   {
//                     time: "13/10/24",
//                     text: "Submitted DPP-3 Biology.",
//                   },
//                   {
//                     time: "10/10/24",
//                     text: "Fees - part payment .",
//                   },
//                   { time: "09/10/24", text: "Submitted DPP-3 Zoology." },
//                   {
//                     time: "05/10/24",
//                     text: "Absent.",
//                   },
//                   {
//                     time: "01/10/24",
//                     text: "Test Submitted TTS-4 Chemistry.",
//                   },
//                   {
//                     time: "30/09/24",
//                     text: "Test Submitted TTS-3 Chemistry.",
//                   },
//                   { time: "29/09/24", text: "Absent." },
//                   {
//                     time: "28/09/24",
//                     text: "Submitted DPP-2 Zoology.",
//                   },
//                   {
//                     time: "21/09/24",
//                     text: "Submitted DPP-1 Biology.",
//                   },
//                   {
//                     time: "19/09/24",
//                     text: " Submitted DPP-1  Zoology.",
//                   },
//                   {
//                     time: "16/09/24",
//                     text: " Submitted DPP-1 Physics.",
//                   },
//                   {
//                     time: "10/09/24",
//                     text: "Fees - part payment .",
//                   },
//                   {
//                     time: "10/09/24",
//                     text: "Account created.",
//                   },
//                 ].map((activity, index) => (
//                   <div className="timeline-item" key={index}>
//                     <div className="timeline-time">{activity.time}</div>
//                     <div className="timeline-text">{activity.text}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div>
//           <div
//             style={{
//               backgroundColor: "#D6D6D6",
//               color: "#424342",
//               fontWeight: "700",
//               padding: "10px",

//               boxShadow: "4px 4px 4px 0px #00000040",
//             }}
//           >
//             Progress Tracker
//           </div>
//           <div className="card1-student-dashboard second-activity">
//             <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
//               {progressData.length > 0 ? (
//                 <div
//                   style={{
//                     height: "32vh",
//                     width: "1200px",
//                     display: "inline-block",
//                   }}
//                 >
//                   <ResponsiveLine
//                     data={progressData}
//                     margin={{ top: 15, right: 90, bottom: 27, left: 45 }}
//                     xScale={{ type: "point" }}
//                     yScale={{
//                       type: "linear",
//                       min: "auto",
//                       max: "auto",
//                       stacked: false,
//                       reverse: false,
//                     }}
//                     axisTop={null}
//                     axisRight={null}
//                     axisBottom={{
//                       orient: "bottom",
//                       tickSize: 5,
//                       tickPadding: 5,
//                       tickRotation: 0,
//                       legend: "Assessment",
//                       legendOffset: 36,
//                       legendPosition: "middle",
//                     }}
//                     axisLeft={{
//                       orient: "left",
//                       tickSize: 5,
//                       tickPadding: 5,
//                       tickRotation: 0,
//                       legend: "Marks",
//                       legendOffset: -40,
//                       legendPosition: "middle",
//                     }}
//                     colors={["pink", "lightblue", "lightgreen", "orange"]}
//                     pointSize={10}
//                     pointColor={{ theme: "background" }}
//                     pointBorderWidth={2}
//                     pointBorderColor={{ from: "serieColor" }}
//                     useMesh={true}
//                     legends={[
//                       {
//                         anchor: "bottom-right",
//                         direction: "column",
//                         justify: false,
//                         translateX: 100,
//                         translateY: 0,
//                         itemsSpacing: 0,
//                         itemDirection: "left-to-right",
//                         itemWidth: 80,
//                         itemHeight: 20,
//                         itemOpacity: 0.75,
//                         symbolSize: 12,
//                         symbolShape: "circle",
//                         symbolBorderColor: "rgba(0, 0, 0, .5)",
//                         effects: [
//                           {
//                             on: "hover",
//                             style: {
//                               itemBackground: "rgba(0, 0, 0, .03)",
//                               itemOpacity: 1,
//                             },
//                           },
//                         ],
//                       },
//                     ]}
//                   />
//                 </div>
//               ) : (
//                 <p>Loading progress data...</p>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <div
//         className="student-dashboard-content"
//         style={{ marginBottom: "10px" }}
//       >
//         <div
//           className="card-student-dashboard-4-cards"
//           style={{ position: "relative" }}
//         >
//           <button
//             className="top-right-button"
//             style={{
//               position: "absolute",
//               top: "-1px",
//               right: "-1px",
//               width: "20px",
//               height: "20px",
//               backgroundColor: "lightgray",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             <img src={RedArrow} alt="" />
//           </button>
//           DPP
//           <div className="progress-bar-container">
//             <div
//               className="progress-bar-segment submitted"
//               style={{ width: "50%" }}
//             ></div>
//             <div
//               className="progress-bar-segment in-progress"
//               style={{ width: "30%" }}
//             ></div>
//             <div
//               className="progress-bar-segment absent"
//               style={{ width: "20%" }}
//             ></div>
//           </div>
//         </div>

//         <div
//           className="card-student-dashboard-4-cards"
//           style={{ position: "relative" }}
//         >
//           <button
//             className="top-right-button"
//             style={{
//               position: "absolute",
//               top: "-1px",
//               right: "-1px",
//               width: "20px",
//               height: "20px",
//               backgroundColor: "lightgray",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             <img src={RedArrow} alt="" />
//           </button>
//           Test
//           <div className="progress-bar-container">
//             <div
//               className="progress-bar-segment submitted"
//               style={{ width: "30%" }}
//             ></div>
//             <div
//               className="progress-bar-segment absent"
//               style={{ width: "70%" }}
//             ></div>
//           </div>
//         </div>

//         <div
//           className="card-student-dashboard-4-cards"
//           style={{ position: "relative" }}
//         >
//           <button
//             className="top-right-button"
//             style={{
//               position: "absolute",
//               top: "-1px",
//               right: "-1px",
//               width: "20px",
//               height: "20px",
//               backgroundColor: "lightgray",
//               border: "none",
//               cursor: "pointer",
//             }}
//             onClick={fetchAttendanceData}
//           >
//             <img src={RedArrow} alt="" />
//           </button>
//           Attendance
//           <div className="progress-bar-container">
//             <div
//               className="progress-bar-segment submitted"
//               style={{ width: "80%" }}
//             ></div>
//             <div
//               className="progress-bar-segment absent"
//               style={{ width: "20%" }}
//             ></div>
//           </div>
//           <a
//             href={attendanceData ? `/attendance-report?student_id=2` : "#"}
//             className="Report-link-student-dashboard"
//           ></a>
//         </div>
//         <div
//           className="card-student-dashboard-4-cards"
//           style={{ position: "relative" }}
//         >
//           <button
//             className="top-right-button"
//             style={{
//               position: "absolute",
//               top: "-1px",
//               right: "-1px",
//               width: "20px",
//               height: "20px",
//               backgroundColor: "lightgray",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             <img src={RedArrow} alt="" />
//           </button>
//           Fees
//           <div className="progress-bar-container">
//             <div
//               className="progress-bar-segment submitted"
//               style={{ width: "50%" }}
//             ></div>
//             <div
//               className="progress-bar-segment absent"
//               style={{ width: "50%" }}
//             ></div>
//           </div>
//         </div>
//       </div>{" "}
//       <div
//         className="row-cs-uni "
//         style={{ marginBottom: "35px", marginLeft: "2vw", width: "82vw" }}
//       >
//         <DropDownUP
//           label="Subject"
//           style={{ width: "20.1%" }}
//           setSelected={setSelectedSubject}
//           selectedLabel={selectedSubjectLabel} // Pass the selected label
//           setSelectedLabel={setSelectedSubjectLabel} // Pass the function to update the selected label
//           options={subjects.map((subject) => ({
//             label: subject.subject_name,
//             id: subject.subject_id,
//           }))}
//           isRequired={true}
//         />

//         <label
//           htmlFor=""
//           style={{
//             paddingTop: "20px",
//             paddingLeft: "25px",
//             paddingRight: "25px",
//           }}
//         >
//           Tabular | Graph
//         </label>
//         <br />
//         <label
//           className={`switch topple user-status ${isClicked ? "no-border" : ""
//             }`}
//         >
//           <input
//             type="checkbox"
//             checked={isClicked} // Bind the checked state to `isClicked`
//             onChange={handleToggle} // Toggle state on change
//           />
//           <span className="slider round"></span>
//         </label>

//         <div className="item5" style={{ padding: "5px" }}>
//           <div
//             className="toggle-radio"
//             style={{ paddingRight: "25px", paddingLeft: "25px" }}
//           >
//             <input
//               type="radio"
//               id="last month"
//               name="month"
//               value="Last Month"
//               checked={value.month === "Last Month"}
//               onChange={(e) => setValues({ ...value, month: e.target.value })}
//               disabled={isApplied}
//             />
//             <label htmlFor="last month">Previous Month</label>
//           </div>
//         </div>
//         <div className="item6" style={{ padding: "5px" }}>
//           <div
//             className="toggle-radio"
//             style={{ paddingRight: "25px", paddingLeft: "25px" }}
//           >
//             <input
//               type="radio"
//               id="month to date"
//               name="month"
//               value="Month to Date"
//               checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
//               onChange={(e) => setValues({ ...value, month: e.target.value })}
//               disabled={isApplied}
//             />
//             <label htmlFor="month to date">Month to Date</label>
//           </div>
//         </div>
//         <div
//           className="item7"
//           style={{
//             paddingRight: "25px",
//             paddingLeft: "25px",
//             paddingTop: "5px",
//           }}
//         >
//           <div className="toggle-radio">
//             <input
//               type="radio"
//               id="week to date"
//               name="month"
//               value="Week to Date"
//               checked={value.month === "Week to Date"}
//               onChange={(e) => setValues({ ...value, month: e.target.value })}
//               disabled={isApplied}
//             />
//             <label htmlFor="week to date">Week to Date</label>
//           </div>
//         </div>
//         <div
//           className="item8"
//           style={{ padding: "5px", paddingLeft: "25px", paddingRight: "25px" }}
//         >
//           <div className="toggle-radio">
//             <input
//               type="radio"
//               id="custom"
//               name="month"
//               value="Custom"
//               checked={value.month === "Custom"}
//               onChange={(e) => setValues({ ...value, month: e.target.value })}
//               disabled={isApplied}
//             />
//             <label htmlFor="custom">Custom</label>
//           </div>
//         </div>
//         {value.month === "Custom" && (
//           <>
//             <div className="item9" style={{ padding: "5px" }}>
//               <FormInputs
//                 type="date"
//                 name="start_month"
//                 value={value.start_month}
//                 onChange={(e) =>
//                   setValues({ ...value, start_month: e.target.value })
//                 }
//                 disabled={isApplied}
//               />
//             </div>
//             <div className="item10" style={{ paddingTop: "18px" }}>
//               To
//             </div>
//             <div className="item11" style={{ padding: "5px" }}>
//               <FormInputs
//                 type="date"
//                 name="end_month"
//                 value={value.end_month}
//                 onChange={(e) =>
//                   setValues({ ...value, end_month: e.target.value })
//                 }
//                 disabled={isApplied}
//               />
//             </div>
//           </>
//         )}
//       </div>
//       {/* /////////////// */}
//       <hr class="new2"></hr>
//       <div style={{ marginTop: "20px" }}>
//         {isClicked ? (
//           // Placeholder for Graph
//           <div className="student-dashboard-content">
//             <div>
//               <div
//                 style={{
//                   backgroundColor: "#D6D6D6",
//                   color: "#424342",
//                   fontWeight: "700",
//                   padding: "10px",
//                   boxShadow: "4px 4px 4px 0px #00000040",
//                 }}
//               >
//                 GRAPH 1 - Attendance Overview
//               </div>
//               <div
//                 className="student-dashboard-line-chart"
//                 style={{ padding: "10px", height: "400px" }}
//               >
//                 <ResponsivePie
//                   data={pieChartData}
//                   margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
//                   innerRadius={0.5}
//                   padAngle={0.7}
//                   cornerRadius={3}
//                   activeOuterRadiusOffset={8}
//                   borderWidth={1}
//                   borderColor={{
//                     from: "color",
//                     modifiers: [["darker", 0.2]],
//                   }}
//                   arcLinkLabelsSkipAngle={10}
//                   arcLinkLabelsTextColor="#333333"
//                   arcLinkLabelsThickness={2}
//                   arcLinkLabelsColor={{ from: "color" }}
//                   arcLabelsSkipAngle={10}
//                   arcLabelsTextColor={{
//                     from: "color",
//                     modifiers: [["darker", 2]],
//                   }}
//                   legends={[
//                     {
//                       anchor: "bottom",
//                       direction: "row",
//                       justify: false,
//                       translateX: 0,
//                       translateY: 56,
//                       itemsSpacing: 0,
//                       itemWidth: 100,
//                       itemHeight: 18,
//                       itemTextColor: "#999",
//                       itemDirection: "left-to-right",
//                       itemOpacity: 1,
//                       symbolSize: 18,
//                       symbolShape: "circle",
//                       effects: [
//                         {
//                           on: "hover",
//                           style: {
//                             itemTextColor: "#000",
//                           },
//                         },
//                       ],
//                     },
//                   ]}
//                 />
//               </div>
//             </div>

//             {/* Add more graphs below or other components as needed */}
//             <div>
//               <div
//                 style={{
//                   backgroundColor: "#D6D6D6",
//                   color: "#424342",
//                   fontWeight: "700",
//                   padding: "10px",
//                   boxShadow: "4px 4px 4px 0px #00000040",
//                 }}
//               >
//                 GRAPH 2
//               </div>
//               <div className="student-dashboard-bar-chart"></div>
//             </div>
//           </div>
//         ) : (
//           // TableComponent when not clicked
//           <TableComponent
//             headers={headers}
//             data={attendanceData}
//             searchPlaceholder="Search attendance..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             isExpanded={isExpanded}
//             ReportPageHeader="Attendance Report"
//           />
//         )}
//       </div>
//       <div className="student-dashboard-content">
//         <div>
//           <div
//             style={{
//               backgroundColor: "#D6D6D6",
//               color: "#424342",
//               fontWeight: "700",
//               padding: "10px",
//               boxShadow: "4px 4px 4px 0px #00000040",
//             }}
//           >
//             NOTES
//           </div>
//           <div
//             className="student-dashboard-line-chart"
//             style={{ padding: "10px", overflow: "auto" }}
//           >
//             <ul className="custom-list">
//               {items.slice(0, -1).map((item, index) => (
//                 <li
//                   key={index}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     whiteSpace: "pre-wrap",
//                     color: item.isRed ? "#FA4741" : "#424242", // Apply red color if isRed is true
//                   }}
//                 >
//                   <span style={{ color: "grey", marginRight: "5px" }}>
//                     {item.date}
//                   </span>
//                   <span style={{ color: "grey", marginRight: "5px" }}>
//                     [{item.username}]
//                   </span>
//                   {item.text}
//                 </li>
//               ))}
//             </ul>

//             <div
//               onDoubleClick={handleDoubleClick}
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <span
//                 style={{
//                   width: "8px",
//                   height: "8px",
//                   backgroundColor: "#424242",
//                   borderRadius: "50%",
//                   display: "inline-block",
//                   marginRight: "12px",
//                 }}
//               ></span>
//               <span style={{ color: "grey", marginRight: "5px" }}>
//                 {items[items.length - 1]?.date}
//               </span>
//               <span style={{ color: "grey", marginRight: "5px" }}>
//                 [{userName}]
//               </span>
//               <span
//                 style={{
//                   whiteSpace: "pre-wrap",
//                   color: items[items.length - 1]?.isRed ? "#FA4741" : "#424242", // Apply red color to the last saved item if isRed is true
//                 }}
//               >
//                 {items[items.length - 1]?.text}
//               </span>
//             </div>

//             {inputVisible && (
//               <>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginTop: "10px",
//                   }}
//                 >
//                   <span
//                     style={{
//                       width: "8px",
//                       height: "8px",
//                       backgroundColor: "#424242",
//                       borderRadius: "50%",
//                       display: "inline-block",
//                       marginRight: "12px",
//                     }}
//                   ></span>
//                   <span style={{ color: "grey", marginRight: "5px" }}>
//                     {/* {dayjs().format("DD/MM/YY")} */}
//                     {dayjs().format('YYYY-MM-DD HH:mm:ss')}
//                   </span>
//                   <span style={{ color: "grey", marginRight: "5px" }}>
//                     [{userName}]
//                   </span>
//                   <textarea
//                     ref={textareaRef}
//                     value={inputValue}
//                     onChange={handleInputChange}
//                     onKeyDown={handleKeyDown}
//                     style={{
//                       width: "30vw",
//                       maxHeight: "20vh",
//                       border: "none",
//                       backgroundColor: "transparent",
//                       resize: "none",
//                       overflow: "hidden",
//                       whiteSpace: "pre-wrap",
//                       wordWrap: "break-word",
//                       outline: "none",
//                       color:
//                         isChecked || inputValue.startsWith("@KeepRed")
//                           ? "#FA4741"
//                           : "#424242", // Textarea turns red if checkbox is checked or if @KeepRed is typed
//                     }}
//                     rows={1}
//                     placeholder="Type your note and press Enter"
//                   />
//                 </div>
//                 <input
//                   style={{ marginLeft: "8.8vw", marginTop: "5px" }}
//                   type="checkbox"
//                   checked={isChecked}
//                   onChange={handleCheckboxChange} // Handle checkbox state for new note
//                 />
//               </>
//             )}
//           </div>
//         </div>

//         <div>
//           <div
//             style={{
//               backgroundColor: "#D6D6D6",
//               color: "#424342",
//               fontWeight: "700",
//               padding: "10px",
//               boxShadow: "4px 4px 4px 0px #00000040",
//             }}
//           >
//             EXAM READINESS
//           </div>
//           <div className="student-dashboard-bar-chart">
//             <div style={{ marginTop: "110px" }}>
//               <ReactSpeedometer
//                 value={61.9}
//                 currentValueText="Student Readiness meter"
//                 minValue={0}
//                 maxValue={100}
//                 height={400}
//                 width={400}
//                 customSegmentLabels={[
//                   {
//                     text: "Very Bad",
//                     position: "INSIDE",
//                     color: "#555",
//                   },
//                   {
//                     text: "Bad",
//                     position: "INSIDE",
//                     color: "#555",
//                   },
//                   {
//                     text: "Ok",
//                     position: "INSIDE",
//                     color: "#555",
//                     fontSize: "19px",
//                   },
//                   {
//                     text: "Good",
//                     position: "INSIDE",
//                     color: "#555",
//                   },
//                   {
//                     text: "Very Good",
//                     position: "INSIDE",
//                     color: "#555",
//                   },
//                 ]}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default StudentDashboard;

import React, { useEffect, useState, useRef } from "react";
import "./studentdashboard.css";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";
import DropDownUP from "./DropwondownSingleStudent";
import FormInputs from "../Reports/DummyReportPage/FormInputs";
import RedArrow from "../../Assets/Images/CommanImages/More_up_arrow.png";
import TableComponent from "../Reports/components/TableCompoenent";
import InterogativeImg from "./../../Assets/Images/CommanImages/Warning.png";
import dayjs from "dayjs";
import ReactSpeedometer from "react-d3-speedometer";
import { ResponsivePie } from "@nivo/pie";
import { API_BASE_URL } from "../../Config/Config";
import FemaleImg from "../../Assets/Images/EployeeRegistration/female_avater.png";
import MaleImg from "../../Assets/Images/EployeeRegistration/male_avatar.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import { GET } from "../../Api/HttpsMethods";
import EndPoints from "../../Api/Endpoints";
import { POST } from "../../Api/HttpsMethods";

const getAttendanceBarData = (data) => {
  let present = 0;
  let absent = 0;
  let holidays = 0;
  let working = 0;

  data.forEach((item) => {
    if (item.day_type === "Holiday") {
      holidays++;
    } else if (item.day_type === "Working") {
      working++;
      if (item.punch_in !== null) {
        present++;
      } else {
        absent++;
      }
    }
  });

  return [
    {
      status: "Attendance",
      Present: present,
      Absent: absent,
      Holiday: holidays,
      Working: working,
    },
  ];
};

const processAttendanceData = (data) => {
  let present = 0;
  let absent = 0;
  let holidays = 0;

  data.forEach((item) => {
    if (item.day_type === "Holiday") {
      holidays++;
    } else if (item.day_type === "Working" && item.punch_in !== null) {
      present++;
    } else if (item.day_type === "Working" && item.punch_in === null) {
      absent++;
    }
  });

  return [
    { id: "Present", label: "Present", value: present },
    { id: "Absent", label: "Absent", value: absent },
    { id: "Holiday", label: "Holiday", value: holidays },
  ];
};

// Helper to process attendance for Graph 1 (Present/Absent)
const getPresentAbsentData = (data) => {
  let present = 0;
  let absent = 0;
  data.forEach((item) => {
    if (item.day_type === "Working" && item.punch_in !== null) {
      present++;
    } else if (item.day_type === "Working" && item.punch_in === null) {
      absent++;
    }
  });
  return [
    { id: "Present", label: "Present", value: present },
    { id: "Absent", label: "Absent", value: absent },
  ];
};

// Helper to process attendance for Graph 2 (Present, Working, Holiday, Absent)
const getFullAttendanceData = (data) => {
  let present = 0;
  let absent = 0;
  let holidays = 0;
  let working = 0;
  data.forEach((item) => {
    if (item.day_type === "Holiday") {
      holidays++;
    } else if (item.day_type === "Working") {
      working++;
      if (item.punch_in !== null) {
        present++;
      } else {
        absent++;
      }
    }
  });
  return [
    { id: "Present", label: "Present", value: present },
    { id: "Working", label: "Working", value: working },
    { id: "Holiday", label: "Holiday", value: holidays },
    { id: "Absent", label: "Absent", value: absent },
  ];
};

const StudentDashboard = ({
  dataClient,
  selectedStudentID,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
}) => {
  // console.log("values from endpoint" + EndPoints.GetStudentProfileDetails);
  const [studentData, setStudentData] = useState(null);
  const [progressData, setProgressData] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [courseOpted, setCourseOpted] = useState("1");
  const [isApplied, setIsApplied] = useState(false);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  // const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attendanceDataRaw, setAttendanceDataRaw] = useState([]);
  const [attendanceTableData, setAttendanceTableData] = useState([]);

  const [showTestTable, setShowTestTable] = useState(false);
  const [testTableData, setTestTableData] = useState([]);

  const pieChartData = getPresentAbsentData(attendanceDataRaw);
  const graph2Data = getFullAttendanceData(attendanceDataRaw);
  const attendanceBarData = getAttendanceBarData(attendanceDataRaw);

  const [activeTableType, setActiveTableType] = useState(null); // null | "attendance" | "test" | "dpp" | "fees"

  const headers = ["Date", "Day", "Day Type", "Punch In"];
  const [value, setValues] = useState({
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [],
    start_month: "",
    end_month: "",
    subject_id: [],
  });
  const [items, setItems] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputVisible, setInputVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const textareaRef = useRef(null);
  const [finalUserName, setFinalUserName] = useState("");
  const [studentImgUrl, setStudentImgUrl] = useState(null);
  const scrollRef = useRef(null);
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const accessToken = localStorage.getItem("other");

  useEffect(() => {
    if (dataClient?.client_schema_name?.[6]?.[0]?.user_name) {
      setFinalUserName(dataClient.client_schema_name[6][0].user_name);
    }
  }, [dataClient]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // Add this useEffect to scroll when items change or when the component mounts
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [items]);

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();

      if (inputValue.trim()) {
        const isRed = inputValue.startsWith("@KeepRed");
        const cleanText = isRed
          ? inputValue.replace("@KeepRed", "").trim()
          : inputValue;

        const newItem = {
          date: dayjs().format("YYYY-MM-DD HH:mm"),
          username: finalUserName,
          text: cleanText,
          isChecked: isChecked,
          isRed: isRed || isChecked,
        };

        // Post the note to the server
        await postStudentNote(cleanText, isChecked);

        // Update the local state
        setItems((prevItems) => [...prevItems, newItem]);
        setInputValue("");
        setInputVisible(false);
        setIsChecked(false);
        if (textareaRef.current) {
          textareaRef.current.style.height = "auto";
        }
      }
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set to scrollHeight
    }
  }, [inputValue]);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev); // Toggle checkbox state
  };

  const handleDoubleClick = () => {
    setInputVisible(true); // Show the input field on double-click
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      if (courseOpted) {
        const url = `${EndPoints.GetSubjectsByCourse}?course_id=${courseOpted}`;
        const data = await GET.noToken(url, {
          setMessageBox,
          setIsMessageBoxVisible,
          setActiveImg,
          ErrorImg,
        });
        setSubjects(Array.isArray(data) ? data : []);
        setSelectedSubjectLabel("");
      }
    };
    fetchSubjects();
  }, [courseOpted]);

  useEffect(() => {
    const fetchStudentProfile = async () => {
      if (selectedStudentID) {
        const url = `${EndPoints.GetStudentProfileDetails}?student_id=${selectedStudentID}`;
        const data = await GET.noToken(url, {
          setMessageBox,
          setIsMessageBoxVisible,
          setActiveImg,
          ErrorImg,
        });
        if (
          data &&
          data.status === 200 &&
          Array.isArray(data.data) &&
          data.data.length > 0
        ) {
          setStudentData(data.data[0]);
          if (data.signed_url && data.signed_url !== "URL not found") {
            setStudentImgUrl(data.signed_url);
          } else {
            setStudentImgUrl(null);
          }
        }
      }
    };
    fetchStudentProfile();
  }, [selectedStudentID]);

  const fetchProgressCard = async () => {
    if (selectedStudentID) {
      const url = `${EndPoints.GetStudentProgressCard}?student_id=${selectedStudentID}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });

      if (Array.isArray(data)) {
        const subjects = ["Physics", "Chemistry", "Botany", "Zoology", "Overall"];

        const transformed = subjects.map((subject) => ({
          id: subject,
          data: data.map((record) => ({
            x: record.assessment_name,
            z: record.assignment_date,
            y: record[`${subject}_total_marks`] ?? 0, // use 0 if missing
          })),
        }));

        setProgressData(transformed);
      }
    }
  };

  useEffect(() => {
    if (selectedStudentID) {
      fetchProgressCard();
    }
  }, [selectedStudentID]);

  const fetchAttendanceData = async () => {
    const { start, end } = getStartEndDates(value.month);

    const url = `${
      EndPoints.GetStudentAttendance
    }?student_id=${selectedStudentID}&start_date=${encodeURIComponent(
      start
    )}&end_date=${encodeURIComponent(end)}`;
    const data = await GET.noToken(url, {
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      ErrorImg,
    });

    if (Array.isArray(data)) {
      // Set raw object data for pie chart processing
      setAttendanceDataRaw(data);

      // Set array format for table component
      const tableData = data.map((item) => [
        item.date_ || "N/A",
        item.day_ || "N/A",
        item.day_type || "N/A",
        item.punch_in ? item.punch_in : "Absent",
      ]);
      setAttendanceTableData(tableData);
    } else {
      console.error("Unexpected data format:", data);
    }
  };

  useEffect(() => {
    if (selectedStudentID && clientBranchId) {
      fetchAttendanceData();
    }
  }, [
    value.month,
    value.start_month,
    value.end_month,
    selectedStudentID,
    clientBranchId,
  ]);

  const barData = [
    {
      year: "2003",
      hotdog: 130,
      burger: 150,
      sandwich: 70,
    },
    {
      year: "2004",
      hotdog: 190,
      burger: 250,
      sandwich: 120,
    },
    {
      year: "2005",
      hotdog: 230,
      burger: 200,
      sandwich: 170,
    },
  ];

  const handleToggle = () => {
    setIsClicked((prev) => !prev);
  };

  const postStudentNote = async (noteText, disciplinaryFlag) => {
    const url = `${
      EndPoints.AddStudentNote
    }?student_id=${selectedStudentID}&note_text=${encodeURIComponent(
      noteText
    )}&branch_id=${clientBranchId}&username=${userName}&device=web&disciplinary_flag=${disciplinaryFlag}`;
    const data = await POST.withToken(
      url,
      {},
      {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      }
    );
    return data;
  };

  const fetchStudentNotes = async () => {
    if (!selectedStudentID || !clientBranchId) {
      setItems([]);
      return;
    }
    const url = `${EndPoints.GetStudentNotes}?student_id=${selectedStudentID}&branch_id=${clientBranchId}`;
    const data = await GET.withToken(url, {
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      ErrorImg,
    });
    if (data && data.status === 200 && Array.isArray(data.data)) {
      const formattedNotes = data.data.map((note) => ({
        date: dayjs(note.create_date).format("YYYY-MM-DD HH:mm"),
        text: note.note_text,
        isChecked: note.disciplinary_flag,
        isRed: note.disciplinary_flag,
        username: note.username,
      }));
      setItems(formattedNotes);
    } else {
      setItems([]);
      console.error("Unexpected response format:", data);
    }
  };

  useEffect(() => {
    if (clientBranchId && selectedStudentID) {
      fetchStudentNotes(clientBranchId);
    }
  }, [clientBranchId, selectedStudentID]);

  console.log(studentData, "student data");

  const getStartEndDates = (monthOption) => {
    const today = dayjs();
    switch (monthOption) {
      case "Last Month":
        return {
          start: today
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD HH:mm:ss"),
          end: today
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
      case "Month to Date":
        return {
          start: today.startOf("month").format("YYYY-MM-DD HH:mm:ss"),
          end: today.format("YYYY-MM-DD HH:mm:ss"),
        };
      case "Week to Date":
        return {
          start: today.startOf("week").format("YYYY-MM-DD HH:mm:ss"),
          end: today.format("YYYY-MM-DD HH:mm:ss"),
        };
      case "Custom":
        return {
          start: dayjs(value.start_month)
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          end: dayjs(value.end_month)
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
      default:
        return {
          start: today.startOf("month").format("YYYY-MM-DD HH:mm:ss"),
          end: today.format("YYYY-MM-DD HH:mm:ss"),
        };
    }
  };

  const handleTestCardClick = () => {
    if (progressData.length === 0) return;

    const tableRows = [];

    // Get all unique x-values (assessment names)
    const assessments = progressData[0].data.map((entry) => entry.x);

    assessments.forEach((assessment, index) => {
      const row = [assessment];
      progressData.forEach((subjectData) => {
        const y = subjectData.data[index]?.y ?? 0;
        row.push(y);
      });
      tableRows.push(row);
    });

    setTestTableData(tableRows);
    setShowTestTable(true);
  };

  useEffect(() => {
    setActiveTableType(null);
  }, [selectedStudentID]);

  return (
    <>
      {studentData ? (
        <div
          className="row-cs-uni header-student-dashboard"
          style={{ marginBottom: "15px" }}
        >
          <div
            className="col-cs2-uni-landing-student"
            style={{ color: "#424242" }}
          >
            <img
              src={
                studentImgUrl
                  ? studentImgUrl
                  : studentData.Gender === 1
                  ? MaleImg
                  : FemaleImg
              }
              className="student_img_dashboard-student"
              alt="Student Avatar"
            />
          </div>
          <div
            className="col-cs2-uni-landing-student3"
            style={{ color: "#424242" }}
          >
            <h2 className="spaceing-student-details bottomAligned">
              {studentData.student_full_name}
            </h2>
            <p className="spaceing-student-details">
              Roll Number: {studentData.Roll_Number}
            </p>
          </div>
          <div
            className="col-cs2-uni-landing-student2"
            style={{ color: "#424242" }}
          >
            <p className="spaceing-student-details top-margin-student">
              Branch: {studentData.Branch_name}
            </p>
            <p className="spaceing-student-details">
              Class Type: {studentData.class_type}
            </p>
            <p className="spaceing-student-details">
              Course: {studentData.Course_Name}
            </p>
            <p className="spaceing-student-details">
              Class: {studentData.Class_name}
            </p>
            <p className="spaceing-student-details">
              Batch: {studentData.Batch}
            </p>
          </div>
        </div>
      ) : (
        <p>Loading student data...</p>
      )}
      <div
        className="student-dashboard-content"
        style={{ marginBottom: "15px" }}
      >
        <div>
          <div
            style={{
              backgroundColor: "#D6D6D6",
              color: "#424342",
              fontWeight: "700",
              padding: "10px",

              boxShadow: "4px 4px 4px 0px #00000040",
            }}
          >
            Recent Activity
          </div>
          <div className="card1-student-dashboard recent-activity">
            <div className="timeline-wrapper">
              <div className="timeline" style={{ opacity: "0.6" }}>
                {[
                  {
                    time: "16/10/24",
                    text: "  Submitted DPP-2 Physics.",
                  },
                  {
                    time: "15/10/24",
                    text: " Test Submitted Test-5 Chemistry.",
                  },
                  {
                    time: "13/10/24",
                    text: "Submitted DPP-3 Biology.",
                  },
                  {
                    time: "10/10/24",
                    text: "Fees - part payment .",
                  },
                  { time: "09/10/24", text: "Submitted DPP-3 Zoology." },
                  {
                    time: "05/10/24",
                    text: "Absent.",
                  },
                  {
                    time: "01/10/24",
                    text: "Test Submitted TTS-4 Chemistry.",
                  },
                  {
                    time: "30/09/24",
                    text: "Test Submitted TTS-3 Chemistry.",
                  },
                  { time: "29/09/24", text: "Absent." },
                  {
                    time: "28/09/24",
                    text: "Submitted DPP-2 Zoology.",
                  },
                  {
                    time: "21/09/24",
                    text: "Submitted DPP-1 Biology.",
                  },
                  {
                    time: "19/09/24",
                    text: " Submitted DPP-1  Zoology.",
                  },
                  {
                    time: "16/09/24",
                    text: " Submitted DPP-1 Physics.",
                  },
                  {
                    time: "10/09/24",
                    text: "Fees - part payment .",
                  },
                  {
                    time: "10/09/24",
                    text: "Account created.",
                  },
                ].map((activity, index) => (
                  <div className="timeline-item" key={index}>
                    <div className="timeline-time">{activity.time}</div>
                    <div className="timeline-text">{activity.text}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div
            style={{
              backgroundColor: "#D6D6D6",
              color: "#424342",
              fontWeight: "700",
              padding: "10px",

              boxShadow: "4px 4px 4px 0px #00000040",
            }}
          >
            Progress Tracker
          </div>
          <div className="card1-student-dashboard second-activity">
            <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
              {progressData.length > 0 ? (
                <div
                  style={{
                    height: "34vh",
                    width: "1200px",
                    display: "inline-block",
                  }}
                >
                  <ResponsiveLine
                    data={progressData}
                    margin={{ top: 38, right: 90, bottom: 27, left: 45 }}
                    xScale={{ type: "point" }}
                    yScale={{
                      type: "linear",
                      min: "auto",
                      max: "auto",
                      stacked: false,
                      reverse: false,
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      orient: "bottom",
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: "Assessment",
                      legendOffset: 36,
                      legendPosition: "middle",
                    }}
                    axisLeft={{
                      orient: "left",
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: "Marks",
                      legendOffset: -40,
                      legendPosition: "middle",
                    }}
                    colors={["pink", "lightblue", "lightgreen", "orange"]}
                    pointSize={10}
                    pointColor={{ theme: "background" }}
                    pointBorderWidth={2}
                    pointBorderColor={{ from: "serieColor" }}
                    useMesh={true}
                    legends={[
                      {
                        anchor: "bottom-right",
                        direction: "column",
                        justify: false,
                        translateX: 100,
                        translateY: 0,
                        itemsSpacing: 0,
                        itemDirection: "left-to-right",
                        itemWidth: 80,
                        itemHeight: 20,
                        itemOpacity: 0.75,
                        symbolSize: 12,
                        symbolShape: "circle",
                        symbolBorderColor: "rgba(0, 0, 0, .5)",
                        effects: [
                          {
                            on: "hover",
                            style: {
                              itemBackground: "rgba(0, 0, 0, .03)",
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]}
                  />
                </div>
              ) : (
                <p>Loading progress data...</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="student-dashboard-content"
        style={{ marginBottom: "10px" }}
      >
        <div
          className="card-student-dashboard-4-cards"
          style={{ position: "relative" }}
        >
          <button
            className="top-right-button"
            style={{
              position: "absolute",
              top: "-1px",
              right: "-1px",
              width: "20px",
              height: "20px",
              backgroundColor: "lightgray",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleTestCardClick}
          >
            <img src={RedArrow} alt="" />
          </button>
          DPP
          <div className="progress-bar-container">
            <div
              className="progress-bar-segment submitted"
              style={{ width: "50%" }}
            ></div>
            <div
              className="progress-bar-segment in-progress"
              style={{ width: "30%" }}
            ></div>
            <div
              className="progress-bar-segment absent"
              style={{ width: "20%" }}
            ></div>
          </div>
        </div>

        <div
          className="card-student-dashboard-4-cards"
          style={{ position: "relative" }}
        >
          <button
            className="top-right-button"
            style={{
              position: "absolute",
              top: "-1px",
              right: "-1px",
              width: "20px",
              height: "20px",
              backgroundColor: "lightgray",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => setActiveTableType("test")}
          >
            <img src={RedArrow} alt="" />
          </button>
          Test
          <div className="progress-bar-container">
            <div
              className="progress-bar-segment submitted"
              style={{ width: "30%" }}
            ></div>
            <div
              className="progress-bar-segment absent"
              style={{ width: "70%" }}
            ></div>
          </div>
        </div>
        <div
          className="card-student-dashboard-4-cards"
          style={{ position: "relative" }}
        >
          <button
            className="top-right-button"
            style={{
              position: "absolute",
              top: "-1px",
              right: "-1px",
              width: "20px",
              height: "20px",
              backgroundColor: "lightgray",
              border: "none",
              cursor: "pointer",
            }}
            // onClick={fetchAttendanceData}
            onClick={() => setActiveTableType("attendance")}
          >
            <img src={RedArrow} alt="" />
          </button>
          Attendance
          <div className="progress-bar-container">
            <div
              className="progress-bar-segment submitted"
              style={{ width: "80%" }}
            ></div>
            <div
              className="progress-bar-segment absent"
              style={{ width: "20%" }}
            ></div>
          </div>
          <a
            href={
              attendanceTableData
                ? `/attendance-report?student_id=${selectedStudentID}`
                : "#"
            }
            className="Report-link-student-dashboard"
          ></a>
        </div>
        <div
          className="card-student-dashboard-4-cards"
          style={{ position: "relative" }}
        >
          <button
            className="top-right-button"
            style={{
              position: "absolute",
              top: "-1px",
              right: "-1px",
              width: "20px",
              height: "20px",
              backgroundColor: "lightgray",
              border: "none",
              cursor: "pointer",
            }}
          >
            <img src={RedArrow} alt="" />
          </button>
          Fees
          <div className="progress-bar-container">
            <div
              className="progress-bar-segment submitted"
              style={{ width: "50%" }}
            ></div>
            <div
              className="progress-bar-segment absent"
              style={{ width: "50%" }}
            ></div>
          </div>
        </div>
      </div>{" "}
      <div
        className="row-cs-uni "
        style={{ marginBottom: "35px", marginLeft: "2vw", width: "82vw" }}
      >
        <DropDownUP
          label="Subject"
          style={{ width: "20.1%" }}
          setSelected={setSelectedSubject}
          selectedLabel={selectedSubjectLabel} // Pass the selected label
          setSelectedLabel={setSelectedSubjectLabel} // Pass the function to update the selected label
          options={subjects.map((subject) => ({
            label: subject.subject_name,
            id: subject.subject_id,
          }))}
          isRequired={true}
        />

        <label
          htmlFor=""
          style={{
            paddingTop: "20px",
            paddingLeft: "25px",
            paddingRight: "25px",
          }}
        >
          Tabular | Graph
        </label>
        <br />
        <label
          className={`switch topple user-status ${
            isClicked ? "no-border" : ""
          }`}
        >
          <input
            type="checkbox"
            checked={isClicked} // Bind the checked state to `isClicked`
            onChange={handleToggle} // Toggle state on change
          />
          <span className="slider round"></span>
        </label>

        <div className="item5" style={{ padding: "5px" }}>
          <div
            className="toggle-radio"
            style={{ paddingRight: "25px", paddingLeft: "25px" }}
          >
            <input
              type="radio"
              id="last month"
              name="month"
              value="Last Month"
              checked={value.month === "Last Month"}
              onChange={(e) => setValues({ ...value, month: e.target.value })}
              disabled={isApplied}
            />
            <label htmlFor="last month">Previous Month</label>
          </div>
        </div>
        <div className="item6" style={{ padding: "5px" }}>
          <div
            className="toggle-radio"
            style={{ paddingRight: "25px", paddingLeft: "25px" }}
          >
            <input
              type="radio"
              id="month to date"
              name="month"
              value="Month to Date"
              checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
              onChange={(e) => setValues({ ...value, month: e.target.value })}
              disabled={isApplied}
            />
            <label htmlFor="month to date">Month to Date</label>
          </div>
        </div>
        <div
          className="item7"
          style={{
            paddingRight: "25px",
            paddingLeft: "25px",
            paddingTop: "5px",
          }}
        >
          <div className="toggle-radio">
            <input
              type="radio"
              id="week to date"
              name="month"
              value="Week to Date"
              checked={value.month === "Week to Date"}
              onChange={(e) => setValues({ ...value, month: e.target.value })}
              disabled={isApplied}
            />
            <label htmlFor="week to date">Week to Date</label>
          </div>
        </div>
        <div
          className="item8"
          style={{ padding: "5px", paddingLeft: "25px", paddingRight: "25px" }}
        >
          <div className="toggle-radio">
            <input
              type="radio"
              id="custom"
              name="month"
              value="Custom"
              checked={value.month === "Custom"}
              onChange={(e) => setValues({ ...value, month: e.target.value })}
              disabled={isApplied}
            />
            <label htmlFor="custom">Custom</label>
          </div>
        </div>
        {value.month === "Custom" && (
          <>
            <div className="item9" style={{ padding: "5px" }}>
              <FormInputs
                type="date"
                name="start_month"
                value={value.start_month}
                onChange={(e) =>
                  setValues({ ...value, start_month: e.target.value })
                }
                disabled={isApplied}
              />
            </div>
            <div className="item10" style={{ paddingTop: "18px" }}>
              To
            </div>
            <div className="item11" style={{ padding: "5px" }}>
              <FormInputs
                type="date"
                name="end_month"
                value={value.end_month}
                onChange={(e) =>
                  setValues({ ...value, end_month: e.target.value })
                }
                disabled={isApplied}
              />
            </div>
          </>
        )}
      </div>
      {/* /////////////// */}
      <hr class="new2"></hr>
      <div style={{ marginTop: "20px" }}>
        {isClicked ? (
          // Placeholder for Graph
          <div className="student-dashboard-content">
            <div>
              <div
                style={{
                  backgroundColor: "#D6D6D6",
                  color: "#424342",
                  fontWeight: "700",
                  padding: "10px",
                  boxShadow: "4px 4px 4px 0px #00000040",
                }}
              >
                GRAPH 1 - Attendance Overview
              </div>
              <div
                className="student-dashboard-line-chart"
                style={{ padding: "10px", height: "400px" }}
              >
                <ResponsivePie
                  data={pieChartData}
                  margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                  innerRadius={0.5}
                  padAngle={0.7}
                  cornerRadius={3}
                  activeOuterRadiusOffset={8}
                  borderWidth={1}
                  borderColor={{
                    from: "color",
                    modifiers: [["darker", 0.2]],
                  }}
                  arcLinkLabelsSkipAngle={10}
                  arcLinkLabelsTextColor="#333333"
                  arcLinkLabelsThickness={2}
                  arcLinkLabelsColor={{ from: "color" }}
                  arcLabelsSkipAngle={10}
                  arcLabelsTextColor={{
                    from: "color",
                    modifiers: [["darker", 2]],
                  }}
                  legends={[
                    {
                      anchor: "bottom",
                      direction: "row",
                      justify: false,
                      translateX: 0,
                      translateY: 56,
                      itemsSpacing: 0,
                      itemWidth: 100,
                      itemHeight: 18,
                      itemTextColor: "#999",
                      itemDirection: "left-to-right",
                      itemOpacity: 1,
                      symbolSize: 18,
                      symbolShape: "circle",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemTextColor: "#000",
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
            </div>

            {/* Add more graphs below or other components as needed */}
            <div>
              <div
                style={{
                  backgroundColor: "#D6D6D6",
                  color: "#424342",
                  fontWeight: "700",
                  padding: "10px",
                  boxShadow: "4px 4px 4px 0px #00000040",
                }}
              >
                GRAPH 2
              </div>
              <div className="student-dashboard-bar-chart">
                <ResponsiveBar
                  data={attendanceBarData}
                  keys={["Present", "Absent", "Holiday", "Working"]}
                  indexBy="status"
                  margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                  padding={0.3}
                  valueScale={{ type: "linear" }}
                  indexScale={{ type: "band", round: true }}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Status",
                    legendPosition: "middle",
                    legendOffset: 32,
                  }}
                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Count",
                    legendPosition: "middle",
                    legendOffset: -40,
                  }}
                  labelSkipWidth={12}
                  labelSkipHeight={12}
                  legends={[
                    {
                      dataFrom: "keys",
                      anchor: "bottom-right",
                      direction: "column",
                      translateX: 120,
                      itemWidth: 100,
                      itemHeight: 16,
                      itemsSpacing: 3,
                      symbolSize: 18,
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {activeTableType === "test" && (
              <TableComponent
                headers={[
                  "Assessment Name",
                  "Physics",
                  "Chemistry",
                  "Botany",
                  "Zoology",
                  "Total Marks",
                  "Assessment Date",
                ]}
                data={
                  progressData.length
                    ? progressData[0].data.map((_, idx) => [
                        progressData[0].data[idx].x, // assessment name
                        progressData[0].data[idx].y, // Physics
                        progressData[1]?.data[idx]?.y ?? 0, // Chemistry
                        progressData[2]?.data[idx]?.y ?? 0, // Botany
                        progressData[3]?.data[idx]?.y ?? 0, // Zoology
                        progressData[4]?.data[idx]?.y ?? 0,  // Total Marks
                        progressData[0]?.data[idx]?.z
                          ? new Date(progressData[0].data[idx].z).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                          : "-"
                      ])
                    : []
                }
                searchPlaceholder="Search test scores..."
                isColumnDivVisible={isColumnDivVisible}
                setIsColumnDivVisible={setIsColumnDivVisible}
                isExpanded={isExpanded}
                ReportPageHeader="Test Score Table"
              />
            )}

            {activeTableType === "attendance" && (
              <TableComponent
                headers={headers}
                data={attendanceTableData}
                searchPlaceholder="Search attendance..."
                isColumnDivVisible={isColumnDivVisible}
                setIsColumnDivVisible={setIsColumnDivVisible}
                isExpanded={isExpanded}
                ReportPageHeader="Attendance Report"
              />
            )}
          </>
        )}
      </div>
      <div className="student-dashboard-content">
        <div>
          <div
            style={{
              backgroundColor: "#D6D6D6",
              color: "#424342",
              fontWeight: "700",
              padding: "10px",
              boxShadow: "4px 4px 4px 0px #00000040",
            }}
          >
            NOTES
          </div>
          <div
            className="student-dashboard-line-chart"
            style={{ padding: "10px", overflow: "auto" }}
            ref={scrollRef}
          >
            <ul className="custom-list">
              {items.map((item, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    marginBottom: "5px",
                  }}
                >
                  <span
                    style={{
                      color: "grey",
                      marginRight: "5px",
                      minWidth: "120px",
                    }}
                  >
                    {item.date}
                  </span>
                  <div style={{ flex: "1" }}>
                    <span style={{ color: "grey" }}>[{item.username}]</span>
                    <span
                      style={{
                        whiteSpace: "pre-wrap", // Preserve formatting and line breaks
                        wordBreak: "break-word", // Handle long words
                        marginLeft: "5px", // Spacing between username and text
                        color: item.isRed ? "#FA4741" : "#424242",
                      }}
                    >
                      {item.text}
                    </span>
                  </div>
                </li>
              ))}
            </ul>

            <div
              style={{
                alignItems: "flex-start",
              }}
            >
              <div style={{ display: "flex", flex: "1" }}>
                <span
                  style={{
                    width: "11px",
                    height: "8px",
                    marginTop: "4px",
                    backgroundColor: "#424242",
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: "12px",
                  }}
                ></span>
                <span
                  style={{
                    color: "grey",
                    marginRight: "5px",
                    minWidth: "120px",
                  }}
                >
                  {dayjs().format("YYYY-MM-DD HH:mm")}
                </span>
                <span style={{ color: "grey", marginRight: "5px" }}>
                  [{userName}]
                </span>
                <textarea
                  ref={textareaRef}
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  className="custom-textarea"
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "transparent",
                    resize: "none",
                    overflow: "auto",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    outline: "none",
                    color:
                      isChecked || inputValue.startsWith("@KeepRed")
                        ? "#FA4741"
                        : "#424242",
                  }}
                  // rows={3}
                  rows={1}
                  placeholder="Type your note and press Enter"
                />
              </div>
              <div className="checkbox-container-dispy-flag">
                <label>Disciplinary Flag</label>
                <input
                  className="stu-db-disciplinary-flag-checkbox"
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            style={{
              backgroundColor: "#D6D6D6",
              color: "#424342",
              fontWeight: "700",
              padding: "10px",
              boxShadow: "4px 4px 4px 0px #00000040",
            }}
          >
            EXAM READINESS
          </div>
          <div className="student-dashboard-bar-chart">
            <div style={{ marginTop: "110px", opacity: "0.6" }}>
              <ReactSpeedometer
                value={20}
                minValue={0}
                maxValue={100}
                segments={100}
                width={400}
                height={300}
                needleColor="#4d4d4d"
                currentValueText="Student Readiness"
                showSegmentLabels={false} // hides inner segment labels
                ringWidth={60}
                maxSegmentLabels={0} // hides arc tick numbers
                needleTransitionDuration={4000}
                needleTransition="easeElastic"
                needleHeightRatio={0.7}
                textColor="#424242"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentDashboard;
